import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-word-plugin',
  templateUrl: './word-plugin.component.html',
  styleUrls: ['./word-plugin.component.scss']
})
export class wordpluginComponent implements OnInit, AfterViewInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Free Grammar Check Plugin para Microsoft Word - Trinka');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka plug-in para Word torna a escrita mais fácil do que nunca!  Corrija erros gramaticais e obtenha sugestões avançadas enquanto escreve. Experimente o Trinka gratuitamente!' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka-Plug na Microsoft' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka verifica automaticamente sua escrita e muda conforme você escreve. Trinka faz 3000+ verificações gramaticais e dá-lhe dicas de escrita antecipada. Use a ferramenta de verificação gramática gratuitamente' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/pt/wordplugin' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'pt-pt' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/pt/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/wordplugin' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../assets/js/wisepop.js', function () { });
      if (navigator.userAgent.indexOf("WOW64") != -1 ||
        navigator.userAgent.indexOf("Win64") != -1) {
        document.getElementById("windowInfo64bit").innerHTML = '<a  style="color:#FFF" href="https://s3.amazonaws.com/trinka-word-plugin/64bit/Trinka.Installer.msi" target="_blank"><img src="../../../assets/images/whitePaper_download.png" alt="whitepaper" style="width: 26px; margin: -6.5px 10px 0 0;"> Baixe Agora</a>';
      } else {
        document.getElementById("windowInfo64bit").innerHTML = '<a style="color:#FFF" href="https://s3.amazonaws.com/trinka-word-plugin/32bit/Trinka.Installer.msi" target="_blank"><img src="../../../assets/images/whitePaper_download.png" alt="whitepaper" style="width: 26px; margin: -6.5px 10px 0 0;"> Baixe Agora</a>';
      }
      var OSName="Unknown OS";
        if (navigator.appVersion.indexOf("Win")!=-1){
          OSName="Windows";
          $("#MacMSWordButton").css("display", "none");
        }
        if (navigator.appVersion.indexOf("Mac")!=-1){
          OSName="MacOS";
          $("#MSWindowDownloadButton").css("display", "none");
          $("#MSWindowTextContent").css("display", "none");
          $("#MacMSWordButton").css("display", "block");
        } 
        if (navigator.appVersion.indexOf("X11")!=-1){
          OSName="UNIX";
          $("#MacMSWordButton").css("display", "none");
        }
        if (navigator.appVersion.indexOf("Linux")!=-1){
          OSName="Linux";
          $("#MacMSWordButton").css("display", "none");
        }
    }

    ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()})
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit(){
    $('#closedPopup, #wordPluginPopup').click(function () {
      $('iframe.youtubeVideoForTryDemo').remove()
    });
    
    $('#VewiVideoSection').click(function () {
      if (!$('#iframe').length) {
        $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/cTo16u94rxc" width="100%" height="450"></iframe>');
      }
    });
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }

}
